// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__AKYpF","label":"Labeled_label__2V4Aw","divider":"Labeled_divider__bADbn"};